import script from "./PopUp.vue?vue&type=script&setup=true&lang=ts"
export * from "./PopUp.vue?vue&type=script&setup=true&lang=ts"

import "./PopUp.vue?vue&type=style&index=0&id=c739e9f2&lang=css"

const __exports__ = script;

export default __exports__